module.exports = __webpack_public_path__ + "images/collector-aa86c7adabec8c7b11eb4d532d023bc9.png";